import React from 'react';
import {NavLink} from "react-router-dom";
import { useTranslation } from "react-i18next";

const AboutUsComponent = () => {
    const { t } = useTranslation();

    const scrollToBlock = (blockClass: string) => {
        const block = document.querySelector(`.${blockClass}`);
        if (block) {
            block.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="aboutUsComponent__container">
            <div className="aboutUsComponent__container-content-wrap">
                <div className="aboutUsComponent__container-content">
                    <div className="aboutUsComponent__container--content-block first">
                        <div className="aboutUsComponent__container-content-title-wrap">
                            <div className="aboutUsComponent__container-content-title-text">
                                <span>{t('main.customerInfo')}</span>
                            </div>
                        </div>
                        <div className="aboutUsComponent__container-content-list-wrap">
                            <div className="aboutUsComponent__container-content-list">
                                <ul>
                                    <li>
                                        <NavLink to="/help-with-order" >{t('navbar.helpWithOrder')}</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/profile" >{t('main.userProfile')}</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/my-codes" >{t('main.myCodes')}</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="aboutUsComponent__container--content-block second">
                        <div className="aboutUsComponent__container-content-title-wrap">
                            <div className="aboutUsComponent__container-content-title-text">
                                <span>{t('main.aboutWondr')}</span>
                            </div>
                        </div>
                        <div className="aboutUsComponent__container-content-list-wrap">
                            <div className="aboutUsComponent__container-content-list">
                                <ul>
                                    <li>
                                        <NavLink to="/how-it-works"
                                                 onClick={() => {
                                                     scrollToBlock('linkSection__container');
                                                 }}
                                        >{t('navbar.howItWorks')}</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/mobile-app"
                                                 onClick={() => {
                                                     scrollToBlock('mobileAppSectionComponent__container');
                                                 }}
                                        >{t('navbar.mobileApp')}</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/food" >{t('navbar.food')}</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="aboutUsComponent__container--content-block third">
                        <div className="aboutUsComponent__container-content-title-wrap">
                            <div className="aboutUsComponent__container-content-title-text">
                                <span>{t('main.legal')}</span>
                            </div>
                        </div>
                        <div className="aboutUsComponent__container-content-list-wrap">
                            <div className="aboutUsComponent__container-content-list">
                                <ul>
                                    <li>
                                        <NavLink to="/" >{t('main.privacySecurity')}</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/privacy-policy" >{t('main.privacyPolicy')}</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/" >{t('main.termsConditions')}</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="aboutUsComponent__container-line-wrap">
                <div className="aboutUsComponent__container-line"></div>
            </div>
        </div>
    );
};

export default AboutUsComponent;